import React, { useEffect } from 'react'
import { useUser } from '../../providers/UserProvider';

// The app's alert colours for the names callers pass.
const COLORS = {
    green: 'rgb(71, 177, 116)',
    red: 'rgb(255, 85, 85)',
    blue: 'rgb(114, 62, 216)',
};

export const useToggleTop=(message, color)=>{
    const {toggleTop, setToggleTop} = useUser();

    const setToggle =(msg, color)=>{
        toggleTop.color= String(color) ?? "blue";
        toggleTop.message= String(msg) ?? "toggle top";
        toggleTop.toggle=true;
        setToggleTop({...toggleTop});
    }
    return setToggle;
}

// Banner across the top of the page, like the app's drop-down alerts.
const ToggleTop = () => {

    const {toggleTop, setToggleTop} = useUser();
    const message = toggleTop.message ?? "Toggle top component.";
    const color = COLORS[toggleTop.color] ?? toggleTop.color ?? COLORS.blue;

    useEffect(() => {
        const timer = setTimeout(() => {
            setToggleTop({ color: "skyblue", message: "toggle top", toggle: false });
        }, 2600);
        return () => clearTimeout(timer);
    }, [toggleTop.message, toggleTop.color, setToggleTop]);

    return (
            <div
                className='msg'
                role='status'
                style={{
                    position: 'fixed',
                    width: '100%',
                    background: color,
                    top: '0px',
                    left: 0,
                    zIndex: '100',
                    color: 'white',
                    textAlign:'center',
                    padding:'14px 20px',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 600,
                    fontSize: '15px',
                    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
                 }}
                >
                    {message}
            </div>
    )
}

export default ToggleTop
